import { t } from "i18next"

export const InquiryType = [
  { label: t("All"), value: "" },
  { label: t("customerRelated"), value: "customer_related" },
  { label: t("user_related"), value: "user_related" },
  { label: t("others"), value: "others" },
]
